// src/components/ScrollToTop.js (Modified)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Accept scrollContainerRef as a prop
function ScrollToTop({ scrollContainerRef }) {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('Current pathname:', pathname);
    console.log('Attempting to scroll to top...');

    // Check if the ref exists and has a current DOM element
    if (scrollContainerRef && scrollContainerRef.current) {
      console.log('Scrolling specific container:', scrollContainerRef.current);
      scrollContainerRef.current.scrollTo(0, 0); // Scroll the container
    } else {
      console.log('No specific container ref, falling back to window.scrollTo');
      window.scrollTo(0, 0); // Fallback, though likely not the main scroller here
    }
  }, [pathname, scrollContainerRef]); // Add scrollContainerRef to dependencies

  return null;
}

export default ScrollToTop;